export const GET_ROBOT_SUCCESS = 'MAP_GET_ROBOT_SUCCESS';
export const SELECT_ROBOT_ID = 'MAP_SELECT_ROBOT';
export const GET_MAPS_REQUEST = 'MAP_GET_MAPS_REQUEST';
export const GET_MAPS_SUCCESS = 'MAP_GET_MAPS_SUCCESS';
export const GET_MAPS_FAILURE = 'MAP_GET_MAPS_FAILURE';
export const UPDATE_MAP_REQUEST = 'MAP_UPDATE_MAP_REQUEST';
export const UPDATE_MAP_SUCCESS = 'MAP_UPDATE_MAP_SUCCESS';
export const UPDATE_MAP_FAILURE = 'MAP_UPDATE_MAP_FAILURE';
